import { PROCARE_COLORS } from "src/constants/constants";

/*
 * Palette for the three left-column dashboard charts, taken from
 * graph/graph1.svg, graph2.svg and graph3.svg.
 *
 * Anything the app-wide PROCARE_COLORS already defines is re-used rather than
 * re-declared, so a future brand change flows through in one place.
 */

export const CHART_COLORS = {
  // Shared chrome
  title: "#525252",
  label: "#6B6C6D",
  mutedLabel: "#A4A4A4",
  axisLine: "#D9D9D9",
  gridLine: "#E5E5E5",
  border: "#E5E5E5",

  // Pill toggles
  toggleTrack: "#F2F2F2",
  toggleTrackAlt: "#F4F5F7",
  toggleSelected: "#FFFFFF",
  toggleTextSelected: PROCARE_COLORS.primaryBlue, // #00A1E4
  toggleText: "#757575",

  // graph1 - Earnings Overview
  earnedFrom: "#0AB7FF",
  earnedTo: PROCARE_COLORS.primaryGreen, // #17D68F
  projected: PROCARE_COLORS.orange, // #FFB74D
  barCap: PROCARE_COLORS.primaryBlue,
  accent: PROCARE_COLORS.primaryBlue,
  grandTotalFill: "#15B177",
  grandTotalText: "#159A69",

  // graph2 - Hours Worked Trend
  trendLine: PROCARE_COLORS.primaryBlue,
  trendAreaTop: "#E9F6FC",
  trendAreaBottom: "#FFFFFF",
  // Hours vs Amount metric backgrounds
  hoursBackground: "#E6F4FD",
  amountBackground: "#F8DEE8",
  // Hours vs Amount metric line colors
  hoursLine: PROCARE_COLORS.primaryGreen, // #17D68F
  amountLine: "#15B177",

  // graph3 - Request Status Overview
  statusNew: "#8ECDE4",
  statusApprovalInProcess: PROCARE_COLORS.primaryBlue,
  statusCompAdminReview: "#2A5280",
  statusRejected: PROCARE_COLORS.red, // #E57373
  statusTrack: "#F0F1F5",
  inProgressTotal: "#2B7FC4",
  rejectedTotal: "#D95F5F",
  axisTick: "#99A1AF",
};

/*
 * Gradient stop sets, mirroring SERIES_CONFIG in the mobile
 * EarningsOverviewContent screen so both platforms render the same bars.
 */
export const EARNED_GRADIENT = [
  { offset: 0, color: CHART_COLORS.earnedFrom, opacity: 1 },
  { offset: 1, color: CHART_COLORS.earnedTo, opacity: 0.34 },
];

export const PROJECTED_GRADIENT = [
  { offset: 0.16, color: CHART_COLORS.projected, opacity: 1 },
  { offset: 1, color: CHART_COLORS.projected, opacity: 0.37 },
];

export const TREND_AREA_GRADIENT = [
  { offset: 0, color: CHART_COLORS.trendAreaTop, opacity: 1 },
  { offset: 1, color: CHART_COLORS.trendAreaBottom, opacity: 0 },
];

/* Shared props for every ChartTabStrip toggle on these cards. */
export const TOGGLE_THEME = {
  backgroundColor: CHART_COLORS.toggleTrack,
  selectedTabColor: CHART_COLORS.toggleSelected,
  selectedTextColor: CHART_COLORS.toggleTextSelected,
  textColor: CHART_COLORS.toggleText,
};

/* Granularity strip shared by all three cards. */
export const GRANULARITY_OPTIONS = [
  { label: "Month", value: "month" },
  { label: "Quarter", value: "quarter" },
  { label: "Year", value: "year" },
];

/* graph2's metric strip. */
export const METRIC_OPTIONS = [
  { label: "Hours", value: "hours" },
  { label: "Amount", value: "amount" },
];
